'use strict';

var novicell = novicell || {};

novicell.filterDropdown = novicell.filterDropdown || new function () {

    this.init = function () {
        let dropdowns = document.getElementsByClassName('js-filter-dropdown');
        if (dropdowns.length) {
            document.body.addEventListener('click', () => {
                for (let i = 0; i < dropdowns.length; i++) {
                    let dropdown = dropdowns[i];
                    let list = dropdown.querySelector('.js-filter-dropdown-list');
                    let button = dropdown.querySelector('.js-filter-dropdown-button');
                    list.classList.remove('filter-dropdown-list--active');
                    list.setAttribute('aria-hidden', 'true');
                    button.classList.remove('filter-dropdown-button--active');
                    button.setAttribute('aria-expanded', 'false');
                }
            });
            for (let i = 0; i < dropdowns.length; i++) {
                let dropdown = dropdowns[i];
                let list = dropdown.querySelector('.js-filter-dropdown-list');
                let button = dropdown.querySelector('.js-filter-dropdown-button');
                let search = dropdown.querySelector('.js-filter-dropdown-list-search');
                let no_result = dropdown.querySelector('.js-filter-dropdown-list-item-no-result');
                search.addEventListener('keyup', () => {
                    let languages = list.getElementsByTagName('li');
                    no_result.style.display = 'block';
                    for (let i = 0; i < languages.length; i++) {
                        if (languages[i].classList.contains('js-filter-dropdown-list-item-no-result')) {
                            return;
                        }
                        let link = languages[i].getElementsByTagName('a')[0];
                        let value = link.textContent || link.innerText;
                        if (value.toLowerCase().indexOf(search.value.toLowerCase()) > -1) {
                            languages[i].style.display = '';
                            no_result.style.display = 'none';
                        } else {
                            languages[i].style.display = 'none';
                        }
                    }
                });
                dropdown.addEventListener('click', (event) => {
                    event.stopPropagation();
                });
                button.addEventListener('click', () => {
                    if (list.classList.contains('filter-dropdown-list--active')) {
                        list.classList.remove('filter-dropdown-list--active');
                        button.classList.remove('filter-dropdown-button--active');
                        button.setAttribute('aria-expanded', 'false');
                        list.setAttribute('aria-hidden', 'true');
                    } else {
                        list.classList.add('filter-dropdown-list--active');
                        button.classList.add('filter-dropdown-button--active');
                        button.setAttribute('aria-expanded', 'true');
                        list.setAttribute('aria-hidden', 'false');
                    }
                });
            }
        }
    };
}();
